import { IWidget } from 'common';
import { style } from 'typestyle';
import { GridIcon } from '../../Icons/MobilePlayerIcons/CTA/Grid';
import { ButtonIcon } from '../../Icons/MobilePlayerIcons/CTA/Button';
import { SliderIcon } from '../../Icons/MobilePlayerIcons/CTA/Slider';
import { NoneIcon } from '../../Icons/MobilePlayerIcons/None';

type MobilePlayerCTA = IWidget['settings']['mobile_player_product_cta'];

interface Props {
  mobile_player_product_cta: MobilePlayerCTA;
  onChange: (mobile_player_product_cta: MobilePlayerCTA) => MobilePlayerCTA;
}

export function MobilePlayerProductCTASelector({ mobile_player_product_cta, ...props }: Props) {
  const onChange = (mobile_player_product_cta: MobilePlayerCTA) => {
    props.onChange(mobile_player_product_cta);
  };

  return (
    <div className={selectClass}>
      <div className={itemClass}>
        <GridIcon onClick={() => onChange('grid')} selected={mobile_player_product_cta === 'grid'} />{' '}
        GRID{' '}
      </div>
      <div className={itemClass}>
        <SliderIcon
          onClick={() => onChange('slider')}
          selected={mobile_player_product_cta === 'slider'}
        />{' '}
        SLIDER{' '}
      </div>
      <div className={itemClass}>
        <ButtonIcon
          onClick={() => onChange('button')}
          selected={mobile_player_product_cta === 'button'}
        />{' '}
        BUTTON{' '}
      </div>
      <div className={itemClass}>
        <NoneIcon onClick={() => onChange('none')} selected={mobile_player_product_cta === 'none'} />{' '}
        NONE{' '}
      </div>
    </div>
  );
}

const selectClass = style({
  marginTop: '10px',
  marginBottom: '10px',
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
});

const itemClass = style({
  fontSize: '0.7em',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '50%',
  boxSizing: 'border-box',
  $nest: {
    '& svg': {
      width: '45px',
      height: '45px',
      marginRight: '8px',
      marginBottom: '8px',
    }
  }
});
